module.exports = __webpack_public_path__ + "static/img/protect_7.e961221a.png";